import { Injectable } from '@angular/core';

import { StorageService } from './storage.service';

import { CountryModel } from './country.model';
import { ProviderModel } from './provider.model';
import { PublisherModel } from './publisher.model';
import { PublisherGroupModel } from './publisher-group.model';
import { BrandModel } from '../../shared/brand.model';
import { ColorModel } from '../../shared/color.model';

@Injectable()
export class FilterService {
    private static countries = 'countries';
    private static providers = 'providers';
    private static publishers = 'publishers';
    private static groups = 'groups';
    private static brands = 'brands';
    private static colors = 'colors';

    constructor(private storageService: StorageService) { }

    public setCountries(countries: any[]) {
        if (countries === null)
            this.storageService.remove(FilterService.countries);
        else {
            let countriesList = new Array<CountryModel>();
            for (let country of countries)
                countriesList.push(new CountryModel(country.id, country.countryName, country.countryCode));
            this.storageService.set(FilterService.countries, countriesList);
        }
    }

    public getCountries(): Array<CountryModel> {
        var result = this.storageService.get<Array<CountryModel>>(FilterService.countries);

        if (result === null)
            return new Array<CountryModel>();

        return result;
    }

    public getCountryIds(): Array<number> {
        let countries = this.getCountries();
        let countryIds = new Array<number>();
        for (let country of countries)
            countryIds.push(country.id);
        return countryIds;
    }

    public setProviders(providers: any[]) {
        if (providers === null)
            this.storageService.remove(FilterService.providers);
        else {
            let providersList = new Array<ProviderModel>();
            for (let provider of providers)
                providersList.push(new ProviderModel(provider.id, provider.name, provider.isRtb, provider.nonConfigurable, provider.isFallback));
            this.storageService.set(FilterService.providers, providersList);
        }
    }

    public getProviders(): Array<ProviderModel> {
        var result = this.storageService.get<Array<ProviderModel>>(FilterService.providers);

        if (result === null)
            return new Array<ProviderModel>();

        return result;
    }

    public getNonConfigurableProviders(): Array<ProviderModel> {
        var result = this.storageService.get<Array<ProviderModel>>(FilterService.providers).filter(x => x.nonConfigurable == false);

        if (result === null)
            return new Array<ProviderModel>();

        return result;
    }

    public getProviderIds(): Array<number> {
        let providers = this.getProviders();
        let providerIds = new Array<number>();
        for (let provider of providers)
            providerIds.push(provider.id);
        return providerIds;
    }

    public setPublishers(publishers: any[]) {
        if (publishers === null)
            this.storageService.remove(FilterService.publishers);
        else {
            let publishersList = new Array<PublisherModel>();
            for (let publisher of publishers)
                publishersList.push(new PublisherModel(publisher.publisherId, publisher.publisherName, publisher.groupName));
            this.storageService.set(FilterService.publishers, publishersList);
        }
    }

    public getPublishers(): Array<PublisherModel> {
        var result = this.storageService.get<Array<PublisherModel>>(FilterService.publishers);

        if (result === null)
            return new Array<PublisherModel>();

        return result;
    }

    public getPublisherIds(): Array<number> {
        let publishers = this.getPublishers();
        let publisherIds = new Array<number>();
        for (let publisher of publishers)
            publisherIds.push(publisher.id);
        return publisherIds;
    }

    public setPublisherGroups(publisherGroups: any[]) {
        if (publisherGroups === null)
            this.storageService.remove(FilterService.groups);
        else {
            let groupsList = new Array<PublisherGroupModel>();
            for (let group of publisherGroups)
                groupsList.push(new PublisherGroupModel(group.id, group.name));
            this.storageService.set(FilterService.groups, groupsList);
        }
    }

    public getPublisherGroups(): Array<PublisherGroupModel> {
        var result = this.storageService.get<Array<PublisherGroupModel>>(FilterService.groups);

        if (result === null)
            return new Array<PublisherGroupModel>();

        return result.sort((p1,p2) => p1.name.toLowerCase() > p2.name.toLowerCase() ? 1 : -1);
    }

    public setBrands(brands: any[]) {
        if (brands === null)
            this.storageService.remove(FilterService.brands);
        else {
            let brandsList = new Array<BrandModel>();
            for (let brand of brands)
                brandsList.push(new BrandModel(brand.id, brand.name));
            this.storageService.set(FilterService.brands, brandsList);
        }
    }

    public getBrands(): Array<BrandModel> {
        var result = this.storageService.get<Array<BrandModel>>(FilterService.brands);

        if (result === null)
            return new Array<BrandModel>();

        return result;
    }

    public setColors(colors: any[]) {
        if (colors === null)
            this.storageService.remove(FilterService.colors);
        else {
            let colorsList = new Array<ColorModel>();
            for (let color of colors)
                colorsList.push(new ColorModel(color.entityId, color.entityName, color.color, color.entityType));
            this.storageService.set(FilterService.colors, colorsList);
        }
    }

    public getColors(): Array<ColorModel> {
        var result = this.storageService.get<Array<ColorModel>>(FilterService.colors);

        if (result === null)
            return new Array<ColorModel>();

        return result;
    }
}


// WEBPACK FOOTER //
// ./src/app/core/services/filter.service.ts